import {
    Body1,
    PhoneNumber,
    Stack,
} from '@myphx-engineering/phx-design-system';

import type { PrescriberInfoFragment } from '../../graphql/generated/graphql';
import { ConditionalComponent } from '../utility/ConditionalComponent';

type PrescriberProps = {
    prescriber: PrescriberInfoFragment;
};

export const Prescriber = ({ prescriber }: PrescriberProps) => {
    return (
        <ConditionalComponent condition={!!prescriber}>
            <Stack gap="sm">
                <Body1 data-testid="prescriber-full-name">
                    {prescriber.fullNameWithTitle}
                </Body1>
                {prescriber.phoneNumber && (
                    <PhoneNumber phone={prescriber.phoneNumber} />
                )}
            </Stack>
        </ConditionalComponent>
    );
};
